export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'complete'
    },
    setting: {
        logic: []
    },
    options: {
        complete: 'Complete',
        incomplete: 'Incomplete'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Play Status',
        category: ['User', 'Plays'],
        description: 'Whether play is marked as complete or incomplete.',
        summarise: {
            template: {
                complete: 'Play is marked as complete',
                incomplete: 'Play is marked as incomplete'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['play.status']
    }
}